import React from 'react';

// Utils
import PropTypes from 'prop-types';

// Components
import * as S from './Styled';
import Message from '../Message';

const propTypes = {
  children: PropTypes.string.isRequired,
};

const Normal = ({ children, msgTitle, msgText }) => {
  return (
    <S.ExtLabel>
      <S.Icon />
      <S.Text>{children}</S.Text>
      <Message title={msgTitle} text={msgText} />
    </S.ExtLabel>
  );
};

Normal.propTypes = propTypes;

export default Normal;
